var map = {
	"./1.webp": 397,
	"./10.webp": 398,
	"./11.webp": 399,
	"./2.webp": 400,
	"./3.webp": 401,
	"./4.webp": 402,
	"./5.webp": 403,
	"./6.webp": 404,
	"./7.webp": 405,
	"./8.webp": 406,
	"./9.webp": 407,
	"./fl88.webp": 408,
	"./fl88_o.webp": 409,
	"./gamelist.webp": 410,
	"./ganimal.webp": 411,
	"./gbattle.webp": 412,
	"./gchess.webp": 413,
	"./gegame.webp": 414,
	"./gfish.webp": 415,
	"./glive.webp": 416,
	"./glotto.webp": 417,
	"./gmultiple.webp": 418,
	"./gsport.webp": 419,
	"./knowhow-1.webp": 420,
	"./knowhow-2.webp": 421,
	"./knowhow-3.webp": 422,
	"./knowhow-4.webp": 423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;